import type { PropsWithChildren, ReactNode } from 'react';

type TTabBarItemProps = PropsWithChildren<{
  badge?: ReactNode;
}>;

export const TabBarItem = ({ children, badge }: TTabBarItemProps) => (
  <div className="item">
    <span className="item-inner">
      {children}
      {badge}
    </span>
  </div>
);
